export function trim(str: string) {
  return str.replace(/\0/g, "");
}
